import React from "react";
import InvoicePage from "../Invoices/InvoicePage";

export function InvoiceViewer() {
  return <InvoicePage />;
}
